import Icon from '../components/Icon.vue'

Icon.register({
  'cloud-showers-heavy': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M183.9 370.1c7.7 4.4 10.4 14.2 6 21.8l-64 112c-3 5.2-8.4 8.1-13.9 8.1-2.7 0-5.4-0.7-7.9-2.1-7.7-4.3-10.4-14.1-6-21.8l64-112c4.4-7.8 14.2-10.4 21.8-6zM279.9 370.1c7.7 4.4 10.4 14.2 6 21.8l-64 112c-3 5.2-8.4 8.1-13.9 8.1-2.7 0-5.4-0.7-7.9-2.1-7.7-4.3-10.4-14.1-6-21.8l64-112c4.4-7.8 14.2-10.4 21.8-6zM87.9 370.1c7.7 4.4 10.4 14.2 6 21.8l-64 112c-3 5.2-8.4 8.1-13.9 8.1-2.7 0-5.4-0.7-7.9-2.1-7.7-4.3-10.4-14.1-6-21.8l64-112c4.4-7.8 14.2-10.4 21.8-6zM471.9 370.1c7.7 4.4 10.4 14.2 6 21.8l-64 112c-3 5.2-8.4 8.1-13.9 8.1-2.7 0-5.4-0.7-7.9-2.1-7.7-4.3-10.4-14.1-6-21.8l64-112c4.4-7.8 14.2-10.4 21.8-6zM375.9 370.1c7.7 4.4 10.4 14.2 6 21.8l-64 112c-3 5.2-8.4 8.1-13.9 8.1-2.7 0-5.4-0.7-7.9-2.1-7.7-4.3-10.4-14.1-6-21.8l64-112c4.4-7.8 14.2-10.4 21.8-6zM416 128c53 0 96 43 96 96s-43 96-96 96h-320c-53 0-96-43-96-96 0-42.5 27.8-78.2 66.1-90.8-1.3-6.9-2.1-13.9-2.1-21.2 0-61.9 50.2-112 112-112 43.3 0 80.4 24.8 99 60.8 14.7-17.5 36.4-28.8 61-28.8 44.2 0 80 35.8 80 80 0 5.6-0.5 11-1.6 16.2 0.5 0 1-0.2 1.6-0.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cloud-showers-heavy.js
// module id = 1213
// module chunks = 0